import React, { useState } from "react";
import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import { Visibility } from "@mui/icons-material";
import OrdersDialog from "../Pages/SSSAuto/FakeCustomer/OrdersDialog";

const OrdersCell = ({ data }) => {
  const [dialogOpen, setDialogOpen] = useState(false);

  const hasOrders = data && data.length > 0;
  const count = data ? data.length : 0;

  const handleViewOrders = () => {
    if (hasOrders) {
      setDialogOpen(true);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 1,
        height: "100%",
        minHeight: "52px",
      }}
    >
      {hasOrders && (
        <>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Typography
              variant="body2"
              sx={{ fontSize: "13px", marginRight: "4px" }}
            >
              {`Order${count !== 1 ? "s" : ""}:`}
            </Typography>
            <Typography variant="body2" sx={{ fontSize: "13px" }}>
              {count}
            </Typography>
          </Box>
          <Tooltip title={`View Order${count !== 1 ? "s" : ""}`}>
            <IconButton
              size="small"
              onClick={handleViewOrders}
              sx={{
                color: "#1976d2",
                "&:hover": {
                  backgroundColor: "rgba(25, 118, 210, 0.04)",
                },
              }}
            >
              <Visibility fontSize="small" />
            </IconButton>
          </Tooltip>
        </>
      )}

      {dialogOpen && (
        <OrdersDialog
          open={dialogOpen}
          onClose={() => setDialogOpen(false)}
          orders={data}
        />
      )}
    </Box>
  );
};

export default OrdersCell;
